import {IAppEntity} from "../../entities";
import React from "react";
import {ReferenceTypes} from "../../../enums/ReferenceTypes";
import {VatDetail} from "../../../components/Pages/Catalogs/Vat/VatDetail";
import VatList from "../../../components/Pages/Catalogs/Vat/VatList";
import {CreateVatDto} from "../../../dtos/catalogs/Vat/CreateVatDto";
import {VatTypeService} from "../../../services/catalogs/VatTypeService";
import {NFLookupVatType} from "../../../components/Shared/NewForms/NFLookupVatType";

export const VatTypes: IAppEntity = {
    entityType: "catalog",
    title: "Vat Type",
    pluralTitle: "Vat Types",
    apiUrl: "VatTypes",
    apiEnum: ReferenceTypes.CatalogVatType,
    getDetailViewComponent(
        model: any,
        modelUpdatedEvent: (model: any) => void
    ): any {
        return React.createElement(VatDetail, {
            model: model,
            modelUpdatedEvent: modelUpdatedEvent,
        });
    },
    getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
        React.createElement(VatList, {
            model: model,
            modelUpdatedEvent: modelUpdatedEvent,
        }),
    getLookupComponent(model: any): any {
        return React.createElement(NFLookupVatType, {
            fieldName: model.fieldName,
            title: model.title,
            setSelectedCatalog: model.setSelectedCatalog,
        });
    },
    getDataService() {
        return new VatTypeService(this.apiUrl);
    },
    getEmptyModel(): CreateVatDto {
        return {
            name: "",
            createdDate: new Date(),
        };
    },
};
